import { render } from "./gridDesc.vue?vue&type=template&id=85d9be4a"
import script from "./gridDesc.vue?vue&type=script&lang=js"
export * from "./gridDesc.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__